var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-quotes';
                    var viewUrl = 'sprite.svg#view-icon-quotes';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 40 30',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };